import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLOR, FUENTE } from './tokens';

const COLOR_SEVERIDAD = { bad: COLOR.rojo, warn: COLOR.ambar, info: COLOR.azulClaro };

/**
 * Banda de insights — 3 lecturas accionables del período, calculadas por
 * selectors.calcularInsights (nunca texto fijo acá).
 * @param {{items: Array<{title: string, text: string, severity: 'bad'|'warn'|'info'}>}} props
 */
const InsightBar = ({ items }) => {
    if (!items?.length) return null;
    return (
        <Box sx={{ background: COLOR.negro, borderRadius: '12px', padding: '18px 22px', display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: `repeat(${items.length}, minmax(0, 1fr))` }, gap: '20px' }}>
            {items.map((item) => (
                <Box key={item.title} sx={{ display: 'flex', gap: '12px' }}>
                    <Box sx={{ width: 2, flexShrink: 0, borderRadius: 1, background: COLOR_SEVERIDAD[item.severity] || COLOR.grisFrio }} />
                    <Box>
                        <Typography sx={{ fontFamily: FUENTE, fontSize: 13.5, fontWeight: 700, color: '#fff', marginBottom: '4px' }}>
                            {item.title}
                        </Typography>
                        <Typography sx={{ fontFamily: FUENTE, fontSize: 12.5, color: '#ADB5C1', lineHeight: 1.5 }}>
                            {item.text}
                        </Typography>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default InsightBar;
